export default __webpack_public_path__ + "static/media/vigilance.08bbbb1d.png";